import api from "./api"
import type { MenuItemComplete, MenuItem, ApiResponse, EstruturaRotasCompleta } from "../types"

export const menuService = {
  async listarMenusAtivos(): Promise<MenuItem[]> {
    const response = await api.get<ApiResponse<MenuItem[]>>("/api/menu/ativos")
    return response.data.data || []
  },

  async buscarMenuPorId(id: number): Promise<MenuItem> {
    const response = await api.get<ApiResponse<MenuItem>>(`/api/menu/${id}`)
    return response.data.data!
  },

  async getMenuWithSubmenu(): Promise<MenuItemComplete[]> {
    const response = await api.get<ApiResponse<MenuItemComplete[]>>("/api/menu/with-submenus")
    return response.data.data || []
  },

  async getRotasDinamicas(): Promise<EstruturaRotasCompleta> {
    const response = await api.get<ApiResponse<EstruturaRotasCompleta>>("/api/menu/rotas")
    return response.data.data || { menus: [], routes: [], imports: [] }
  },
}
